import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = { children: ReactNode };
type State = { error: Error | null };

export class StartupBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('MatterMaze startup failed.', error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return <main className="startup-error"><div><img className="auth-logo" src="/mattermaze.png" alt="MatterMaze" /><h1>The app could not start.</h1><p>{this.state.error.message}</p><button onClick={() => window.location.reload()}>Reload</button></div></main>;
  }
}
